module.exports = __webpack_public_path__ + "img/jishugongchengshi.4b70031a.png";